export default "__VITE_ASSET__BtW_eagL__"